import { Component, OnInit, Input } from '@angular/core';
import { Project } from '../project';
import { DbRecordService } from '../db-record.service';
import { RatingService } from '../rating.service';
import { FileService } from '../file.service';
import { UsersService } from '../users.service';

@Component({
  selector: 'app-project-db-records-stats',
  templateUrl: './project-db-records-stats.component.html',
  styleUrls: ['./project-db-records-stats.component.css']
})
export class ProjectDbRecordsStatsComponent implements OnInit {
  @Input() project: Project;


  constructor(
    private dbrs: DbRecordService,
    public rs: RatingService,
    public files: FileService,
    private us: UsersService
  ) { }

  ngOnInit() {
  }

  get total() {
    return this.dbrs.getTotalDbRecordsCount(this.project);
  }

  get stats() {
    return this.rs.stats;
  }

  /*switchMeOnly() {
    this.rs.isMeOnly = !this.rs.isMeOnly;
  }*/

  get users() {
    const ls = [];
    this.project.ratersEmails['abstract'].forEach( u => {
      ls.push([this.us.displayName(u), u]);
    });
    return ls;
  }

  isSelectedUser(tag) {
    return this.rs.selectedUser === tag
  }

  switchUser(tag) {
     if (this.rs.selectedUser === tag) {
       this.rs.selectedUser = null;
     } else {
      this.rs.selectedUser = tag;
     }
  }
}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/project-db-records-stats/project-db-records-stats.component.ts